<ng-container *ngIf="props.img$ | async as img">
  <isp-svg-icon
    *ngIf="img.icon"
    class="textdata__icon"
    [name]="img.icon"
    [width]="img.width"
    [height]="img.height"
  ></isp-svg-icon>
  <img
    *ngIf="img.url"
    class="textdata__image"
    [alt]="props.content$ | async"
    [width]="img.width"
    [src]="img.url"
    [height]="img.height"
  />
</ng-container>

<div
  *ngIf="props.content$ | async as content"
  class="textdata__content ispui-text"
  [style.fontSize]="size$ | async"
  [style.fontFamily]="fontFamily$ | async"
  [ngClass]="{
    'ispui-text_warn': props.isTextHighlight,
    textdata__content_fullwidth: props.isFullWidth
  }"
  [innerHTML]="content"
></div>
